import React from "react";
import FieldError from "./FieldError";

class SAInputComponent extends React.Component {

  render() {
    const {name, error, label, ...attributes} = this.props;
    const errorClassName = error ? " error":'';

    return (
      <div className={`form-field ${errorClassName}`} {...attributes}>
            <label htmlFor={name}>{label}</label>
              {this.props.children}
        {error && (
          <FieldError error={error}/>
        )}
      </div>
    )
  }
}

export default SAInputComponent;
